<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaNo')" prop="fpaNo">
                  <!--FPA编号-->
                  <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaName')" prop="fpaName">
                  <!--FPA名称-->
                  <el-input v-model="queryCondition.fpaName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Facility Name" prop="facilityName">
                  <!--创建人-->
                  <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="'Status'" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TT_FPA" field="REPORT_STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.deadline')" prop="startDate" class="flexBox">
                    <!--到期日期-->
                    <el-date-picker v-model="queryCondition.startDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="PickerOptionsStart" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'To'" prop="endDate" class="flexBox">
                    <el-date-picker v-model="queryCondition.endDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="PickerOptionsEnd" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <div>
        <el-button size="mini" type="primary" @click="fpaReportDownload">Download</el-button>
        <!--FPA 3个月内到期数量 : 29 已过期数量 : 12-->
        {{$t('fpaManage.permanent.toExpireCount')}} : {{toExpireCount}} {{$t('fpaManage.permanent.expiredCount')}} : {{expiredCount}}
      </div>
    </div>
    <el-table :data="tableFpaList" ref="tableFpaList" border highlight-current-row max-height='420'>
      <!--FPA编号-->
      <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" min-width="120px">
      </el-table-column>
      <!-- FPA名称-->
      <el-table-column show-overflow-tooltip prop="fpaName" :label="$t('fpaManage.permanent.fpaName')" min-width="180"></el-table-column>
      <!-- 工厂Code-->
      <el-table-column show-overflow-tooltip prop="facilityCode" label="Facility Code" min-width="100"></el-table-column>
      <!-- 工厂名称-->
      <el-table-column show-overflow-tooltip prop="facilityName" label="Facility Name" min-width="180"></el-table-column>
      <!--productOrCommodityPurchased-->
      <el-table-column show-overflow-tooltip prop="productOrCommodityPurchased" label="Product" min-width="180"></el-table-column>
      <!--FPA有效期开始-->
      <el-table-column show-overflow-tooltip prop="agreementStartDate" label="Start Date" min-width="80">
        <template slot-scope="scope">
          {{scope.row.agreementStartDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--FPA有效期结束-->
      <el-table-column show-overflow-tooltip prop="agreementEndDate" label="End Date" min-width="80">
        <template slot-scope="scope">
          {{scope.row.agreementEndDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--状态-->
      <el-table-column show-overflow-tooltip prop="status" :label="'Status'" min-width="80"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaPermanentApi from "@/api/fpa/fpaPermanent";
import { fileService } from "@/api/common/file-utils";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        facilityName: '',
        status: '',
      },
      tableFpaList: [],
      toExpireCount: 0,
      expiredCount: 0,
      totalCount: null,
      PickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      PickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.queryCondition.status = 'all';
    this.queryData();
    this.queryCount();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      fpaPermanentApi.fpaPermanentReport(this.queryCondition).then(res => {
        console.log('44',res);
        this.tableFpaList = res.resultData;
        this.totalCount = res.totalCount;
      });

    },
    queryCount() {
      fpaPermanentApi.fpaPermanentReportCount().then(res => {
        console.log('res',res);
        this.toExpireCount = res.data.toExpireCount;
        this.expiredCount = res.data.expiredCount;
      });
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        facilityName: '',
        status: '',
      }
      this.queryData();
    },
    fpaReportDownload() {
      fpaPermanentApi.fpaReportDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'FPA报表.xls');
      });
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.text_style {
  display: inline-block;
  position: absolute;
  left: 65px;
}
</style>
